<h2 mat-dialog-title>{{ 'selectABlockingMotive' | i18nextCap }}</h2>
<mat-dialog-content>
  <p>{{ 'blockingMotiveIsRequiredToSetWOToBlockedState' | i18nextCap }}</p>
  <form [formGroup]="form">
    <mat-form-field>
      <mat-label>{{ 'motive' | i18nextCap }}</mat-label>
      <fo-autocompleting-select formControlName="motive" [choices]="motives$" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'notes' | i18nextCap }}</mat-label>
      <textarea matInput formControlName="notes"></textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="basic" [mat-dialog-close]="null">
    {{ 'cancel' | i18nextCap }}
  </button>
  <button
    mat-flat-button
    color="primary"
    [mat-dialog-close]="form.value"
    [disabled]="form.controls.motive.value == null"
  >
    {{ 'continue' | i18nextCap }}
  </button>
</mat-dialog-actions>
